import httpClient from '@/api/httpClient'
import static_api from '@/api/static.api.js'
import Constant from '@/constant/index'

const state = {
  operID: '',
  operName: '',
  operStatus: '',
  defaultFlag: '',
  checkFlag: '',

  email: '',
  pictureURL: '',

  userOnline: false,

  userLogoutClearFlag: false
}

// getters
const getters = {
  // Filtering currentUser
  currentOperInfo: state => {
    return {
      operID: state.operID,
      operName: state.operName,
      operStatus: state.operStatus,
      defaultFlag: state.defaultFlag,
      checkFlag: state.checkFlag,

      email: state.email,
      pictureURL: state.pictureURL
    }
  }

}

// actions
const actions = {

}

// mutations
const mutations = {
  resetOperInfo (state) {
    state.operID = ''
    state.operName = ''
    state.operStatus = ''
    state.defaultFlag = ''
    state.checkFlag = ''
    state.email = ''
  },

  setOperInfo (state, payload) {
    state.operID = payload.operID
    state.operName = payload.operName
    state.operStatus = payload.operStatus
    state.defaultFlag = payload.defaultFlag
    state.checkFlag = payload.checkFlag
    state.email = payload.email
    state.pictureURL = payload.pictureURL
  },

  setUserOnline (state, payload) {
    state.userOnline = payload
  },

  setUserLogoutClearFlag (state, payload) {
    state.userLogoutClearFlag = payload
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
